/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_Plan_BodyInputs */

const en_portal_rail_plan_body = /** @type {(inputs: Portal_Rail_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises, sets and weights written out by your coach.`)
};

const pl_portal_rail_plan_body = /** @type {(inputs: Portal_Rail_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia, serie i ciężary rozpisane przez trenera.`)
};

/**
* | output |
* | --- |
* | "Exercises, sets and weights written out by your coach." |
*
* @param {Portal_Rail_Plan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_plan_body = /** @type {((inputs?: Portal_Rail_Plan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_Plan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_plan_body(inputs)
	return en_portal_rail_plan_body(inputs)
});